import React, { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress, Button, Paper } from '@mui/material';
import Layout from './Layout';
import StripeService from '../services/StripeService';
import { useTranslation } from 'react-i18next';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const ManageSubscriptionPage = () => {
    const { t } = useTranslation();
    const [portalUrl, setPortalUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchPortalUrl = async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await StripeService.createBillingPortalSession();
            setPortalUrl(data.url);
        } catch {
            setError(t('subscription.manageError'));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPortalUrl();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Layout>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                <Paper elevation={3} sx={{ p: 5, maxWidth: 480, width: '100%', textAlign: 'center', borderRadius: 3 }}>
                    <Typography variant="h5" fontWeight={700} gutterBottom>
                        {t('subscription.manageTitle')}
                    </Typography>

                    {loading && (
                        <Box sx={{ mt: 3 }}>
                            <CircularProgress sx={{ color: '#427898' }} />
                            <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
                                {t('subscription.manageLoading')}
                            </Typography>
                        </Box>
                    )}

                    {error && (
                        <Box sx={{ mt: 3 }}>
                            <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>
                            <Button variant="outlined" onClick={fetchPortalUrl}>
                                {t('subscription.retry')}
                            </Button>
                        </Box>
                    )}

                    {portalUrl && !loading && (
                        <Box sx={{ mt: 3 }}>
                            <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
                                {t('subscription.manageDescription')}
                            </Typography>
                            <Button
                                variant="contained"
                                size="large"
                                endIcon={<OpenInNewIcon />}
                                sx={{ backgroundColor: '#427898' }}
                                href={portalUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {t('subscription.openPortal')}
                            </Button>
                        </Box>
                    )}
                </Paper>
            </Box>
        </Layout>
    );
};

export default ManageSubscriptionPage;